import { styled } from "@styles";

import { Accordion, Card, Row } from "react-bootstrap";

export const Wrapper = styled(Accordion)``;

export const OrderItemsCard = styled(Card)`
  margin-bottom: 1rem;
`;

export const OrderItemsCardHeader = styled(Card.Header)``;

export const OrderItemsCardHeaderTitle = styled.p`
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
`;

export const OrderItemsCardBody = styled(Card.Body)`
  background-color: #eee;
`;

export const OrderItemsSellerName = styled.p``;

export const OrderItemsProduct = styled(Row)`
  background-color: white;
  margin: 2rem 0;
  align-items: center;
  text-decoration: ${props => props.canceled == 'true' ? 'line-through' : 'none'};
  cursor: pointer;
`;

export const OrderItemsBrandName = styled.p`
  margin: 0;
`;

export const OrderItemsProductName = styled.p`
  margin: 0;
  font-size: small;
  font-weight: 700;
`;

export const OrderItemsQuantity = styled.p`
  font-weight: 700;
`;

export const OrderItemsPrice = styled.p`
  font-weight: 700;
  float: right;
`;

export const OrderItemsPriceStrike = styled.p`
  font-weight: 700;
  float: right;
  text-decoration: line-through;
`;